import './home.scss';
import { Button, LoadIndicator, ScrollView } from 'devextreme-react';
import { ToolbarSimple } from '../../components';
import { BoardOrdersByServices, BoardPatient, BoardAnalyzers, BoardPersonalInfo, BoardWorkList, BoardPpal, BoardOrdersPendingForMail, BoardOrdersTrends } from './Boards/Index';
import { BoardSalesDashboard } from './Boards/SalesDashboard';
import { SalesDashboardPersonal } from './Boards/SalesDashboardPersonal';
import { ReactNode, useCallback, useEffect } from 'react';
import { Item } from 'devextreme-react/toolbar';
import { useAppDispatch, useAppSelector } from '../../contexts/hooks';
import { setLoadingPpal } from '../../contexts/slices/dashboards';
import { useApiDashBoard } from '../../api/api.dashboards';
import { EReportId, EReportType } from '../../types/types.dashboard';
import { CheckPermissions } from './Components/CheckPermissions';
import moment from 'moment';
import { useScreenSize } from '../../utils/media-query';
export default function Home() {
  const dispatch = useAppDispatch();
  const { getData, getConfigDb } = useApiDashBoard();
  const { dashboards, loading: LoadingDashBoard } = useAppSelector((x) => x.dashboards);
  const userInfo = useAppSelector((x) => x.userInfo.User);
  const localtion = useAppSelector((x) => x.userInfo.Location);
  const systemLocations = useAppSelector((data) => data.configuration.Data?.ComboBox)?.find((x) => x.Name === 'SysI_Sedes')?.Data;
  const perfil = useAppSelector((x) => x.userInfo.Profile);
  const { isSmall, isXSmall } = useScreenSize();
  const handleRefreshClick = () => {
    fetchData();
  };

  useEffect(() => {
    if (dashboards.length === 0) {
      getConfigDb();
    } else {
      fetchData();
    }
  }, [dashboards.length]);

  const fetchData = useCallback(async () => {
    dashboards
      .filter((x) => x.Db_Tipo === EReportType.Dynamic)
      .forEach((dashboard) => {
        if (dashboard.Db_Id && dashboard.Db_Estado) {
          const allowProfiles = dashboard.Db_Permisos.split(',').map((x) => x.trim());
          if (userInfo?.Us_Pe_Id && (allowProfiles.includes(userInfo?.Us_Pe_Id.toString()) || allowProfiles.includes('-1'))) {
            getData(dashboard.Db_Id);
          }
        }
      });
    dispatch(setLoadingPpal(false));
  }, [dashboards, dispatch, getData]);

  const additionalToolbarContent: ReactNode[] = [
    <Item key='refreshButton' location='after'>
      <Button text={isSmall || isXSmall ? '' : 'Actualizar'} icon='refresh' type='default' stylingMode='contained' onClick={handleRefreshClick} />
    </Item>,
  ];
  if (!dashboards || dashboards.length === 0 || LoadingDashBoard) {
    return (
      <div className='view-wrapper-scroll'>
        <ToolbarSimple title='Inicio' additionalToolbarContent={additionalToolbarContent} />
        <div
          className='loading-indicator'
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
            width: '100%',
          }}>
          <LoadIndicator width={40} height={40} />
        </div>
      </div>
    );
  }

  const getName = () => {
    const name = userInfo?.Us_Nombre || 'No disponible';
    const lastName1 = userInfo?.Us_Apellido1 || '';
    const lastName2 = userInfo?.Us_Apellido2 || '';
    //Si es pantalla peque;a o extra-peque;a, solo mostrar el nombre
    if (isSmall || isXSmall) {
      return name;
    }
    return `${name} ${lastName1} ${lastName2}`.trim();
  };

  const getSubtitile = () => {
    const lastLogin = userInfo?.Us_UltimoIngreso ? moment(userInfo.Us_UltimoIngreso).format('DD/MM/YYYY hh:mm A') : moment().format('DD/MM/YYYY hh:mm A');
    const locationName = systemLocations?.find((x) => x.Sd_Id === localtion)?.Sd_Nombre || 'No disponible';
    const profileName = perfil?.Pe_Nombre || 'No disponible';
    // Si es pantalla peque;a o extra-peque;a, solo mostrar el ultimo ingreso y el perfil
    if (isSmall || isXSmall) {
      return `Ult. ingreso: ${lastLogin} | Perfil: ${profileName}\n`;
    }
    return `Ult. ingreso: ${lastLogin} | Sede: ${locationName} | Perfil: ${profileName}`;
  };

  return (
    <ScrollView className='view-wrapper-scroll'>
      <ToolbarSimple title={`Hola. ${getName()}`} subtitle={getSubtitile()} additionalToolbarContent={additionalToolbarContent}>
        <div className='cards'>
          <CheckPermissions columns='four' permissions={dashboards.find((x) => x.Db_Id === EReportId.PpalBoard)?.Db_Permisos || ''} status={dashboards.find((x) => x.Db_Id === EReportId.PpalBoard)?.Db_Estado || false}>
            <BoardPpal />
          </CheckPermissions>
          <CheckPermissions columns='four' permissions={dashboards.find((x) => x.Db_Id === EReportId.PatientsValidation)?.Db_Permisos || ''} status={dashboards.find((x) => x.Db_Id === EReportId.PatientsValidation)?.Db_Estado || false}>
            <BoardPatient />
          </CheckPermissions>
          <CheckPermissions columns='two' permissions={dashboards.find((x) => x.Db_Id === EReportId.SalesBoard)?.Db_Permisos || ''} status={dashboards.find((x) => x.Db_Id === EReportId.SalesBoard)?.Db_Estado || false}>
            <BoardSalesDashboard />
          </CheckPermissions>
          <CheckPermissions columns='two' permissions={dashboards.find((x) => x.Db_Id === EReportId.SalesBoardPersonal)?.Db_Permisos || ''} status={dashboards.find((x) => x.Db_Id === EReportId.SalesBoardPersonal)?.Db_Estado || false}>
            <SalesDashboardPersonal />
          </CheckPermissions>
          <CheckPermissions columns='two' permissions={dashboards.find((x) => x.Db_Id === EReportId.OrdersTrends)?.Db_Permisos || ''} status={dashboards.find((x) => x.Db_Id === EReportId.OrdersTrends)?.Db_Estado || false}>
            <BoardOrdersTrends />
          </CheckPermissions>
          <CheckPermissions columns='two' permissions={dashboards.find((x) => x.Db_Id === EReportId.AreasValidation)?.Db_Permisos || ''} status={dashboards.find((x) => x.Db_Id === EReportId.AreasValidation)?.Db_Estado || false}>
            <BoardWorkList />
          </CheckPermissions>
          <CheckPermissions columns='two' permissions={dashboards.find((x) => x.Db_Id === EReportId.OrdersByServices)?.Db_Permisos || ''} status={dashboards.find((x) => x.Db_Id === EReportId.OrdersByServices)?.Db_Estado || false}>
            <BoardOrdersByServices />
          </CheckPermissions>
          <CheckPermissions columns='two' permissions={dashboards.find((x) => x.Db_Id === EReportId.OrdersPendingForMail)?.Db_Permisos || ''} status={dashboards.find((x) => x.Db_Id === EReportId.OrdersPendingForMail)?.Db_Estado || false}>
            <BoardOrdersPendingForMail />
          </CheckPermissions>
          <CheckPermissions columns='two' permissions={dashboards.find((x) => x.Db_Id === EReportId.GeneralInformation)?.Db_Permisos || ''} status={dashboards.find((x) => x.Db_Id === EReportId.GeneralInformation)?.Db_Estado || false}>
            <BoardPersonalInfo />
          </CheckPermissions>
          <CheckPermissions columns='two' permissions={dashboards.find((x) => x.Db_Id === EReportId.Analyzers)?.Db_Permisos || ''} status={dashboards.find((x) => x.Db_Id === EReportId.Analyzers)?.Db_Estado || false}>
            <BoardAnalyzers />
          </CheckPermissions>
        </div>
      </ToolbarSimple>
    </ScrollView>
  );
}
